import React, { useEffect, Suspense } from "react";
import CircularProgress from '@material-ui/core/CircularProgress';
import "./App.css";
import theme from './theme/theme';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";

//MATERIAL UI
import { ThemeProvider } from "@material-ui/styles";

// páginas
import Login from "./screens/login/Login";
import Callback from "./screens/callback/Callback";

// Componentes personalizados
import Skeleton from "./screens/Skeleton";
import { CognitoProvider, useCognitoProvider } from "./providers/CognitoContext";
import { ErrorProvider } from "./providers/ErrorProvider";
import cognitoUtils from "./utils/cognitoUtils";
import { actions } from "./actions/cognito";
import MenuProvider, { useMenuProvider } from "./providers/MenuContext";
import AssignmentsProvider from './providers/AssignmentsContext';
import BusinessProvider from './providers/BusinessContext';
import { ApiCacheProvider } from './providers/ApiCacheContext';

function InnerApp() {

  const { state, dispatch } = useCognitoProvider();
  const { routes } = useMenuProvider();

  useEffect(() => {
    cognitoUtils.checkSession(() => { dispatch({ type: actions.LOG_OUT }); });
  }, []);

  const renderScreen = (screen) => {
    if (React.isValidElement(screen)) return screen;
    const Screen = screen;
    return <Screen />;
  };

  return (
    <div className="App">
      {
        state && Object.keys(state).length > 0
          ?
          <Skeleton>
            <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}><CircularProgress /></div>}>
              <Switch>
                {
                  routes.map(route => {
                    let routes = [];
                    if((state.impersonated && route.hideFromImpersonated) || (state.admin === false && route.hideFromImpersonated))
                      return [...routes, <Route exact path={route.path}><Redirect to="/mis-datos" /></Route>];
                    if (route.submenu) {
                      const subroutes = route.submenu.map(subroute => <Route exact path={subroute.path}>{renderScreen(subroute.screen)}</Route>)
                      routes = [...routes, subroutes]
                    }
                    routes = [...routes, <Route exact path={route.path}>{renderScreen(route.screen)}</Route>]
                    return routes;
                  })
                }
                <Route path="*" render={() => <Redirect to="/" />} />
              </Switch>
            </Suspense>
          </Skeleton>
          :
          <Switch>
            <Route exact path="/callback">
              <Callback />
            </Route>
            <Route exact path="/login">
              <Login />
            </Route>
            <Route path="*" render={() => <Redirect to="/login" />} />
          </Switch>
      }
    </div>
  );
}

export default function App() {
  return <CognitoProvider>
    <Router>
      <ThemeProvider theme={theme}>
        <ErrorProvider>
          <ApiCacheProvider>
            <BusinessProvider>
              <MenuProvider>
                <AssignmentsProvider>
                  <InnerApp />
                </AssignmentsProvider>
              </MenuProvider>
            </BusinessProvider>
          </ApiCacheProvider>
        </ErrorProvider>
      </ThemeProvider>
    </Router>
  </CognitoProvider>
}